module.exports = __webpack_public_path__ + "img/account_manager.90f1924d.png";